<template>

  <div style="overflow: hidden">

    <div @click="deleteZoom" class="tpl-zoom">
      <img src="https://oss2.1dq.com/app/verify/full.png" width="20px">
    </div>

    <div style="position: absolute ; left: -200px; top: -200px">
      <datetime v-model="date" ref="dateObj"
                type="date"
                zone="Asia/Shanghai"
                format="yyyy-mm-dd"
                :phrases="{ok: '确定', cancel: '取消'}"
                @input="timeClose"
                auto></datetime>
    </div>

    <div class="tpl-box-v31">
      <div id="pageContainer">
      </div>
    </div>
    <!--   wap 按钮-->
    <div class="right-tool-mobile" style="box-shadow: 0 -5px 5px 0 rgb(191,191,191,.2); background: #ffffff;">
      <div class="right-tool-mobile-box flex-center">
        <div style="width: 50%;  " @click="create">
          <div class="btn signed" style="width: 85%">确认填写内容</div>
        </div>
      </div>
    </div>
    <!--    wap 按钮结束-->
  </div>

</template>

<script>

import {PDFManager} from './js/v32/loadPdf'
import {Datetime} from 'vue-datetime';

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

import load from "@/conf/js/load";
import tool from "@/template/js/v32/tool";
import {decode} from "@/common/js/base64";

export default {

  name: "create",
  data() {
    return {
      date: '',
      title: this.$route.query.title, //填写的id
      height: 600, // 页面高度
    };
  },

  components: {Datetime},
  methods: {

    /**
     * 放大
     */
    deleteZoom() {
      let contentNoZoom = "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover";
      let contentZoom = "width=device-width,initial-scale=1.0, minimum-scale=yes, maximum-scale=2.0"
      let content = document.getElementsByName("viewport")[0].getAttribute("content");
      if (content === contentNoZoom)
        this.api.alert("您已经开启双指可放大功能，再次点击可关闭")
      else
        this.api.alert("您已经关闭双指可放大功能，再次点击可开启")
      document.getElementsByName("viewport")[0].setAttribute("content", content === contentZoom ? contentNoZoom : contentZoom);

    },
    /**
     * 时间选择完成
     * @param e
     */
    timeClose(e) {
      if (this.date_id)
        document.getElementById(this.date_id).value = e.slice(0, 10);
    },

    /**
     * 加载pdf
     * @param file_url
     * @param fill_field
     * @param field
     */
    loadPdf(file_url, fill_field, field) {

      PDFManager.loadPDF(file_url, fill_field, field, () => {
        //加载完成
        // tool.updateTimeObj((event, id, value) => {
        //   this.$refs.dateObj.open(event);
        //   this.date_id = id
        //   if (value)
        //     this.date = value
        // });
        //隐藏加载
        // this.api.hideLoading()
      });
    },

    /**
     * 填写合同
     */
    create() {

      let data = tool.getFiledContent();

      let fun = json => {
        this.api.hideLoading()
        if (json.code === 200) {
          let url = this.$route.query.type==='fillPdf' ? `/pages/users/contractManagement/createDoc?file_name=${json.data.file_name}&file_id=${json.data.file_id}&file_url=` : `/pages/convert/details?file_id=${this.$route.query.file_id}`
         return  uni.redirectTo({
            url : url
          })
        }
        this.api.alert(json.msg)
      }

      let params = {
        file_id: this.$route.query.file_id,
        field: data
      }

      this.api.loading()


      this.api.post(this.$route.query.apiHost, params, fun);
    }


  },
  created() {
    load.js("/js/scroll.js")
    this.loadPdf(decode(this.$route.query.file_url));
    this.height = document.documentElement.clientHeight
  }

};
</script>
<style scoped>

.signed {
  font-weight: bold;
  background: #e54d42;
  color: #ffffff !important;
  border: 1px solid #e54d42;
  border-radius: 44px;
  height: 44px;
  box-shadow: 0 5px 7px 0 rgb(235 9 9 / 20%);
}
.tpl-box-v31 {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  max-width: 870px;
}

.flex-center {
  justify-content: center;
}


.tpl-zoom {
  position: fixed;
  cursor: pointer;
  z-index: 9;

  color: rgb(255, 255, 255);

  padding: 10px;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 1px 5px 1px rgb(69 65 78 / 20%);
  border: none;

  display: block;
  text-align: center;

  bottom: 100px;
  right: 20px;
}
</style>
